import { LoadingButton } from '@mui/lab';
import { Box, Card, InputAdornment, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import useAuthUsers from '../../../../../hooks/useAuthUsers';
import { firestore } from '../../../../../contexts/FirebaseContext';

function DescuentosUsers({ dataUser }) {
  const [descuentoUser, setDescuentoUser] = useState(null);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors, isSubmitting }
  } = useForm({
    defaultValues: {
      descuentoValue: descuentoUser?.descuentoValue
    }
  });
  const { currentUser } = useAuthUsers();

  console.log(descuentoUser);

  const onSubmit = async (dataForm) => {
    console.log(dataForm);

    const value = Number(dataForm.descuentoValue);

    if (descuentoUser) {
      await firestore.collection('descuento_usersReg').doc(dataUser.id).update({
        descuentoValue: value,
        updatedAt: new Date()
      });

      await firestore.collection('historial_descuento_usersReg').add({
        userId: dataUser.id,
        createdAt: new Date(),
        typeValue: 'percent',
        newDescuentoValue: value,
        previousDescuentoValue: descuentoUser.descuentoValue,
        operatorUser: currentUser.id
      });
    } else {
      await firestore.collection('descuento_usersReg').doc(dataUser.id).set({
        descuentoValue: value,
        typeValue: 'percent',
        createdAt: new Date(),
        updatedAt: new Date(),
        userId: dataUser.id
      });

      await firestore.collection('historial_descuento_usersReg').add({
        userId: dataUser.id,
        createdAt: new Date(),
        typeValue: 'percent',
        newDescuentoValue: value,
        previousDescuentoValue: 0,
        operatorUser: currentUser.id
      });
    }
  };

  useEffect(() => {
    function getData() {
      firestore
        .collection('descuento_usersReg')
        .doc(dataUser.id)
        .onSnapshot((doc) => {
          if (doc.exists) {
            setDescuentoUser({ id: doc.id, ...doc.data() });
            setValue('descuentoValue', doc.data().descuentoValue);
          }
        });
    }

    getData();
  }, [dataUser.id, setValue]);

  return (
    <Card sx={{ padding: '15px', textAlign: 'center' }}>
      <Typography>Asignar descuento al usuario</Typography>
      <Box component="form" sx={{ marginTop: '15px' }} onSubmit={handleSubmit(onSubmit)}>
        <Box>
          <TextField
            type="number"
            label="Descuento"
            sx={{ m: 1, width: '25ch' }}
            {...register('descuentoValue', { required: true })}
            InputProps={{
              startAdornment: <InputAdornment position="start">%</InputAdornment>
            }}
          />
          {errors.descuentoValue && (
            <Typography color="error" fontSize="13px">
              Ingrese un valor
            </Typography>
          )}
        </Box>

        <LoadingButton sx={{ marginTop: '15px' }} type="submit" variant="contained" loading={isSubmitting}>
          Guardar
        </LoadingButton>
      </Box>
    </Card>
  );
}

export default DescuentosUsers;
